export default "__VITE_ASSET__BZO6k9eC__"